import { BpAnchor } from '../../../../shared/components/text/anchor/BpAnchor'
import React, { Fragment } from 'react'
import { useTranslation } from 'react-i18next'

interface DetailsCellProps {
  link_screen_url: string
  city: string
  country: string
  device: string
}

export const DetailsCell = ({ link_screen_url, city, country, device }: DetailsCellProps) => {
  const { t } = useTranslation()

  return (
    <Fragment>
      <BpAnchor href={link_screen_url} target='_blank'>
        {t('buttons.SERPScreenshot')}
      </BpAnchor>
      <span className='ml-5 text-aqua-300'>{`${city} ${country} | ${device}`}</span>
    </Fragment>
  )
}
